import { render, staticRenderFns } from "./dialogChild.vue?vue&type=template&id=fb0478ea&scoped=true"
import script from "./dialogChild.vue?vue&type=script&lang=js"
export * from "./dialogChild.vue?vue&type=script&lang=js"
import style0 from "./dialogChild.vue?vue&type=style&index=0&id=fb0478ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0478ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb0478ea')) {
      api.createRecord('fb0478ea', component.options)
    } else {
      api.reload('fb0478ea', component.options)
    }
    module.hot.accept("./dialogChild.vue?vue&type=template&id=fb0478ea&scoped=true", function () {
      api.rerender('fb0478ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicData/sopPlatform/dialogChild.vue"
export default component.exports